import arrayContainsArray from './array-contains-array';
import {debounce, debounceDuration} from './debounce';
import randomIntBetweenRange from './random-int-between-range';
import shuffleArray from './shuffle-array';
import shuffleArrayOnce from './shuffle-array-once';
import generateUniqueString from './generate-unique-string';

const Utils = {
  arrayContainsArray,
  debounce,
  debounceDuration,
  randomIntBetweenRange,
  shuffleArray,
  shuffleArrayOnce,
  generateUniqueString,
};

export default Utils;
